import React, { useContext, useState, useEffect } from 'react';

import Container from '../../layouts/Container/Container';
import ProgressBar from '../atoms/ProgressBar';
// import Button from '../atoms/Button';
import TestQuestions from '../organisms/TestQuestions';
import useWidth from '../../hooks/useWidth';
import { StateController } from './../../App';
import { getPrice, getProgressPercent } from '../../utils/functions';
import GoalCounter from '../atoms/GoalCounter';
import SliderRotator from '../organisms/SliderRotator';
import BannerImage from '../molecules/BannerImage';
import CustomModal from '../molecules/CustomModal';

function Progress() {
  const { width } = useWidth();
  const { context } = useContext(StateController);

  const [goalAmount, setGoalAmount] = useState(0);
  const [amount, setAmount] = useState(0);

  const [goalTrx, setGoalTrx] = useState(0);
  const [trx, setTrx] = useState(0);

  const [goalCats, setGoalCats] = useState(0);
  const [currentCats, setCurrentCats] = useState(0);
  const [showModalWinner, setShowModalWinner] = useState(false);
  const [showModalfinishedCampaign, setShowModalfinishedCampaign ] = useState(false);
  const [activeTab, setActiveTab] = useState('meta');
  const [awards, setAwards] = useState([]);
  //const segment = context?.user?.segment ? context.user.segment : '0';
  const [showAllCats, setShowAllCats] = useState(false);
  const VISIBLE_CATS = 6; // cambia a 6/7 si quieres mostrar más por defecto

  function countCategoryOnes(tracing) {
    return Object.entries(tracing)
      .filter(([key, value]) => key.startsWith("category_") && value == 1)
      .length;
  }

   useEffect(() => {
    const now = new Date();
    const startDate = new Date('2026-01-21T23:59:00');

    if (now >= startDate) {
      setShowModalfinishedCampaign(false);
    }
  }, [context])

  useEffect(() => {
    if (context && context.user) {
      setGoalAmount(context.user[`goal_amount_${context.block}`]);
      setGoalCats(context.user[`goal_category_${context.block}`]);
      setGoalTrx(context.user[`goal_trx_${context.block}`]);
    }
    if (context && context.tracing) {
      setAmount(context.tracing[`amount_${context.block}`]);
      setTrx(context.tracing[`trx_${context.block}`]);

      setCurrentCats(
        countCategoryOnes(context.tracing)
      );
       console.log(currentCats);
    }

    if (context && context.awards && context.awards.block_1) {
      const list = []
      const listAwards = context.awards.block_1.awards
      
      if (context.user.segment == "1") {
        // activos
        for (let i = 0; i < listAwards.length; i++) {
          const award = listAwards[i];
          list.push({
            id: award.id,
            image: award.image
          })
        }
      }
      if (context.user.segment == "0") {
        // inactivos
        for (let i = 0; i < listAwards.length; i++) {
          const award = listAwards[i];
          if (
            award.id != 1 || award.id != 7
          ) {
            list.push({
              id: award.id,
              image: award.image
            })
          }
        }
      }

      setAwards(list)
    }

    if (context && context.tracing && context.tracing.winner_1 === 1 && context.user.segment === "0") {
      setShowModalWinner(true)
    }
  }, [context]);

  const dataLayerProgress = (text, link) => {
    window.dataLayer.push({
      event: 'progress',
      text: text,
      link: link
    });
  }

  const redirectAwards = () => {
    window.dataLayer.push({
      event: 'modal_bonus',
      text: 'Conoce más',
      link: '/GanaConMastercardDebit/premios'
    });
    window.location.href = '/GanaConMastercardDebit/premios'
  }

  // const dataLayerAllied = (e, content, link) => {
  //   sendDataLayer({
  //     datalayer: {
  //       event: 'alliances',
  //       text: content,
  //       link: link
  //     },
  //     repeat: true
  //   });
  // }



  // const layer = () => {
  //   sendDataLayer({ datalayer: { event: 'progress', text: 'Ver Gift Cards', link: '/premios' }, repeat: false })
  // }

  const visibleCats = (context?.cats || []).map((c, i) => ({
    ...c,
    _idx: i,
    _active: !!(context?.tracing && context.tracing[`category_${c.id}`]),
  }));

  const listToRender = showAllCats
    ? visibleCats
    : [...visibleCats].sort((a, b) =>
      Number(b._active) - Number(a._active) || a._idx - b._idx
    ).slice(0, VISIBLE_CATS);

  return (
    <div className='mc-page progress slow_ani'>
      <div className='mc-page__progress'>
        <Container>
          {width > 992 &&
            <div className='mc-page__progress--container__image'>
              {/*<img src={`/assets/images/progreso-dk 2.png`} alt="" />*/}

              <div className='mc-page__progress--container__awards'>
                <div className='mc-page__progress--container__awards--overlay'></div>
                <SliderRotator
                  mobileItemsToShow={4}
                  desktopItemsToShow={4}
                  simple={true}
                  list={
                    awards
                  }
                />
              </div>
            </div>
          }

          <div className='mc-page__progress--container'>
            <div className='mc-page__progress--title'>
              {width > 992 ? <>Conoce tu objetivo<br/>y sigue tu progreso</> : <>Conoce tu objetivo<br/>y sigue tu progreso</>}             
            </div>

            {context && context.user.segment === '1' ? (
              <div className='mc-page__progress--subtitle'>
                Realiza compras por un valor de<br/>USD {getPrice(goalAmount)} en {goalCats} categorías.
              </div>
            )
              :
              (
                <div className='mc-page__progress--subtitle'>
                  {/* Realiza compras por un valor de {getPrice(goalAmount)} USD. */}
                  Tu meta es realizar {goalTrx} transacciones por un valor mínimo de USD {goalAmount} cada una.
                </div>
              )
            }

            <div className='mc-page__progress--card'>
              <div className='mc-page__progress--tabs'>
                <button
                  className={`first ${activeTab === 'meta' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab('meta');
                    dataLayerProgress('Objetivo y progreso', '/progreso');
                  }}
                >
                  Objetivo y progreso
                </button>
                <button
                  className={`second ${activeTab === 'record' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab('record');
                    dataLayerProgress('Record de objetivo', '/progreso');
                  }}
                >
                  Récord de objetivo
                </button>
              </div>

              {activeTab === 'meta' && (
                <div className='mc-section-g'>
                  <div className='mc-page__progress--card__t4'>
                    Tu facturación tomará hasta 20 días en verse reflejada. Última actualización: <strong>{context && context.tracing ? context.tracing.date_update : 'Sin actualizar'}</strong>
                  </div>

                  {context &&
                    <div className='mc-page__progress--card__t1'>
                      {(context && context.user.segment == "1")
                        ? 'Así va tu objetivo en facturación:'
                        : 'Así va tu objetivo en transacciones:'
                      }
                    </div>
                  }
                  
                  {context &&
                    <>
                      {(context && context.user.segment == "1")
                        ? <div className='mc-page__progress--card__t2'>
                            Llevas <strong>USD {getPrice(amount)} </strong> de <strong>USD {getPrice(goalAmount)}</strong>
                          </div>
                        : <div className='mc-page__progress--card__t2'>
                            Llevas <strong>{trx}</strong> de <strong>{goalTrx}</strong> transacciones
                          </div>
                      }
                    </>
                  }

                  <ProgressBar
                    percent={getProgressPercent(context)}
                    label={`10/25`}
                  />

                  {context && context.user.segment === '1' ? (
                    <>
                      {/*currentCats >= goalCats
                        ? <p className='mc-page__progress--card__t3'>
                            <strong>Ya compraste en {currentCats} categorías</strong>
                          </p>
                        : <p className='mc-page__progress--card__t3'>
                            <strong>Ya compraste en {currentCats} categorías,</strong> completa al menos {goalCats - currentCats} más y cumple tu meta.
                          </p>
                      */}
                      <p className='mc-page__progress--card__t3'>
                        Recuerda que para cumplir tu objetivo debes realizar compras en al menos <strong>{goalCats}</strong> de estas categorías:
                      </p>
                    </>
                  )
                    :
                    (
                      <>
                      {context && getProgressPercent(context) >= 100 && (
                        <div>
                          <p className='mc-page__progress--card__t3 pes_t2'>
                            Ya cumpliste tu meta, es momento de disfrutar tu e-Gift Card.
                            <button
                              type="button"
                              onClick={() => {
                                dataLayerProgress('Ver e-Gift Card', '/progreso'); 
                                window.location.href = '/GanaConMastercardDebit/premios'
                              }}
                            >
                              Ver e-Gift Card
                            </button>
                          </p>  
                        </div>
                      )}
                      </>
                    )
                  }
                  {context && context.user.segment === '1' && context.cats && (
                    <>
                      <div className='mc-page__progress--card__cats'>
                        {listToRender.map((item) => (
                          <span
                            key={item.id}
                            className={`mc-chip ${item._active ? 'active mc-chip--active' : 'mc-chip--ghost'}`}
                            title={item.name}
                          >
                            {item.name}
                            {item._active && (
                              <svg className="mc-chip__check" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" aria-hidden="true">
                                <path d="M6.66654 11.4064L3.99988 8.73975L4.84988 7.88975L6.66654 9.70642L11.1499 5.22308L11.9999 6.07308L6.66654 11.4064Z" fill="#ffffff" />
                              </svg>
                            )}
                          </span>
                        ))}
                      </div>

                      {context.cats.length > VISIBLE_CATS && (
                        <div className={showAllCats ? 'mc-page__progress--morewrap ' : 'mc-page__progress--morewrap acti'}>
                          <button
                            type="button"
                            className='mc-chip__more-out'
                            onClick={() => {
                              setShowAllCats(!showAllCats);
                              dataLayerProgress(showAllCats ? 'Ver menos' : 'Ver más', '/progreso');
                            }}
                          >
                            {showAllCats ? 'Ver menos' : 'Ver más'}
                          </button>
                        </div>
                      )}
                      {context && getProgressPercent(context) >= 100 && (
                        <div>
                          <p className='mc-page__progress--card__t3 pes_t2'>
                            Ya cumpliste tu meta, es momento de disfrutar tu e-Gift Card.
                            <button
                              type="button"
                              onClick={() => {
                                dataLayerProgress('Ver e-Gift Card', '/progreso');
                                window.location.href = '/GanaConMastercardDebit/premios'
                              }}
                            >
                              Ver e-Gift Card
                            </button>
                          </p>  
                        </div>
                      )}
                    </>
                  )}





                  {/* <div className='mc-page__progress--card__t5'>
                    ¡Logra tus metas y disfruta de una increíble Gift Card digital!
                  </div> */}
                  {/* <div onClick={layer}>
                    <Button
                      type="primary"
                      text="Ver Gift Cards"
                      loading={false}
                      status="active"
                      link="/GanaConMastercardDebit/premios"
                    />
                  </div> */}
                </div>
              )}

              {activeTab === 'record' && (
                <div className='mc-section-g'>
                  <div className='mc-page__progress--card__t1'>
                    <div className='mc-page__progress--card__t1 pes_t2'>
                      Has cumplido tu objetivo:
                    </div>

                    <GoalCounter
                      label={``}
                    />
                    <ProgressBar
                      percent={getProgressPercent(context)}
                      label={`10/25`}
                    />
                    <div className='container-record-meta'>
                      <p className='paragraph-container-goal'>
                        Cada vez que alcances tu objetivo, tendrás una oportunidad de <b>ganar un viaje para dos personas.</b>
                      </p>
                      < a onClick={() => {
                    dataLayerProgress('Conoce más acerca del premio mayor', '/GanaConMastercardDebit/premio-mayor');
                    }} 
                    href="/GanaConMastercardDebit/premio-mayor">Conoce más acerca del premio mayor</a>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

        </Container>

      </div >
      <div className="scroling">
        <a href="#extra">
          <img src="/assets/images/Scroll.png" alt="" />
        </a>
      </div>
      <div className='mc-page__progress--extra' id='extra'>
        <Container>
          {context && 
            <BannerImage
              textLink={'*Aplican Términos y Condiciones.'}
              link={'/GanaConMastercardDebit/terminos-y-condiciones'}
              className='container'
              textButton={'Cómo ganar'}
              linkButton={'/GanaConMastercardDebit/premio-mayor'}
            >
              <h2>
                ¿Te vas a perder Turquía? 
              </h2>
              <p>Participa por un viaje doble a Turquía y recorre Estambul, Capadocia y Ankara. Cada meta cumplida te acerca al premio mayor.</p>
            </BannerImage>
          }
        </Container>
      </div>
{console.log(context)}
      {
        context && context.quiz && (context.quiz.length === 0 || context.quiz.every(q => q.response_1 === null)) &&
        <div>
          <TestQuestions context={context} quizNumber={1}
          />
        </div>
      }
      {showModalWinner && (
        <CustomModal
          title={`¡Ya puedes canjear tu <br/> e-Gift Card!`}
          desc={
              "Canjea tu premio antes del <br/><strong>30 de noviembre de 2026.</strong>"
          }
          cta="Conoce más"
          show={showModalWinner} setShowModal={setShowModalWinner}
          winner={showModalWinner}
          isAwardTerms={true}
          primaryAction={
            {
              action: redirectAwards,
              buttonText: 'Conoce más',
              loading: false
            }
          }
        />
      )}

      {showModalfinishedCampaign && (
        <CustomModal
          title={`La campaña llegó a su fin`}
          desc={
              "Gracias por participar por el concierto del año y demostrar que con tu <strong>Mastercard Débito de Banco Guayaquil sí se gana.</strong><br/><br/>Puedes consultar y descargar los bonos que redimiste antes del cierre de la plataforma, el <strong>5 de febrero.</strong>"
          }
          show={showModalfinishedCampaign} setShowModal={setShowModalfinishedCampaign}
          winner={showModalfinishedCampaign}
          general={true}
          endImage="imagenes.png"
          className="finished-campaign"
          enabledButton={false}
        />
      )}

    </div >
  );
}

export default Progress;
